import { putContractInfo } from '../../../../../api/groupsSetupAPI';
import { getContract, setContractsSaveSuccess, setSetupErrorMessage, setSetupLoading } from '..';
import { fetchGroupSchoolContracts } from './fetchGroupSchoolContracts';

export const updateGroupSchoolContracts = (): AppThunk => async (dispatch, getState) => {
	dispatch(setSetupLoading());

	try {
		const contracts = getContract(getState()) ?? [];
		const payload: Groups.Setup.SchoolContractModel[] = contracts.map(
			({ isEdited, ...contract }) => contract
		);
		const res = await putContractInfo(payload);

		dispatch(fetchGroupSchoolContracts());

		if (res.HasError) {
			dispatch(setSetupErrorMessage(res.Error[0].Message));
		} else {
			dispatch(setContractsSaveSuccess(true));
		}
	} catch (err) {
		dispatch(setSetupErrorMessage(err));
	}
};
